import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className='philosophy-band'>
        <div className='content-container'>
          <h2 className='philosophy-title'>{t('philosophy.title')}</h2>
          <div className='philosophy-cards'>
            <div className='philosophy-card'>
              <h3 className='card-title'>{t('philosophy.1.title')}</h3>
              <p className='card-text'>{t('philosophy.1.text')}</p>
              <a className='card-link' href={t('philosophy.1.link')} target="_blank" rel="noopener noreferrer">
                {t('philosophy.1.linkLabel')}
              </a>
            </div>
            <div className='philosophy-card'>
              <h3 className='card-title'>{t('philosophy.2.title')}</h3>
              <p className='card-text'>{t('philosophy.2.text')}</p>
            </div>
            <div className='philosophy-card'>
              <h3 className='card-title'>{t('philosophy.3.title')}</h3>
              <p className='card-text'>{t('philosophy.3.text')}</p>
            </div>
          </div>
        </div>
      </div>
      <div className='credit-band'>
        <div className='content-container'>
          <span className='credit'>© MB - {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
